/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalCsmsConfigDto } from './ExternalCsmsConfigDto';
import {
    ExternalCsmsConfigDtoFromJSON,
    ExternalCsmsConfigDtoFromJSONTyped,
    ExternalCsmsConfigDtoToJSON,
    ExternalCsmsConfigDtoToJSONTyped,
} from './ExternalCsmsConfigDto';

/**
 * 
 * @export
 * @interface CreateOrganizationRequestDto
 */
export interface CreateOrganizationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrganizationRequestDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestDto
     */
    parentId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestDto
     */
    organizationType: CreateOrganizationRequestDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestDto
     */
    mainLanguage: CreateOrganizationRequestDtoMainLanguageEnum;
    /**
     * External CSMS aggregate (endpoints + charger auth). Pass null to clear CSMS configuration.
     * @type {ExternalCsmsConfigDto}
     * @memberof CreateOrganizationRequestDto
     */
    externalCsmsConfig?: ExternalCsmsConfigDto | null;
}


/**
 * @export
 */
export const CreateOrganizationRequestDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type CreateOrganizationRequestDtoOrganizationTypeEnum = typeof CreateOrganizationRequestDtoOrganizationTypeEnum[keyof typeof CreateOrganizationRequestDtoOrganizationTypeEnum];

/**
 * @export
 */
export const CreateOrganizationRequestDtoMainLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type CreateOrganizationRequestDtoMainLanguageEnum = typeof CreateOrganizationRequestDtoMainLanguageEnum[keyof typeof CreateOrganizationRequestDtoMainLanguageEnum];


/**
 * Check if a given object implements the CreateOrganizationRequestDto interface.
 */
export function instanceOfCreateOrganizationRequestDto(value: object): value is CreateOrganizationRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('mainLanguage' in value) || value['mainLanguage'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestDtoFromJSON(json: any): CreateOrganizationRequestDto {
    return CreateOrganizationRequestDtoFromJSONTyped(json, false);
}

export function CreateOrganizationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'active': json['active'],
        'parentId': json['parentId'],
        'organizationType': json['organizationType'],
        'mainLanguage': json['mainLanguage'],
        'externalCsmsConfig': json['externalCsmsConfig'] == null ? undefined : ExternalCsmsConfigDtoFromJSON(json['externalCsmsConfig']),
    };
}

export function CreateOrganizationRequestDtoToJSON(json: any): CreateOrganizationRequestDto {
    return CreateOrganizationRequestDtoToJSONTyped(json, false);
}

export function CreateOrganizationRequestDtoToJSONTyped(value?: CreateOrganizationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'active': value['active'],
        'parentId': value['parentId'],
        'organizationType': value['organizationType'],
        'mainLanguage': value['mainLanguage'],
        'externalCsmsConfig': ExternalCsmsConfigDtoToJSON(value['externalCsmsConfig']),
    };
}

